import {
  CRAIGSLIST,
  GOOGLE_JOBS,
  ZIP_RECRUITER,
} from 'features/hiring/constants';
import { JobRequestWithDecorators } from 'features/hiringV2/interfaces/IJobRequest';

export const isPremiumBoostsNotAvailable = (
  jobRequest: JobRequestWithDecorators | null,
  partnerName: string
) =>
  !jobRequest ||
  !jobRequest.company_syndicatable ||
  (partnerName === ZIP_RECRUITER && !jobRequest.company_zr_syndicatable);

export const formatPartnerName = (partnerName: string) => {
  switch (partnerName) {
    case ZIP_RECRUITER:
      return 'Zip Recruiter';
    case GOOGLE_JOBS:
      return 'Google Jobs';
    case CRAIGSLIST:
      return 'Craigslist';
    default:
      return partnerName;
  }
};
